var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('date-picker',{attrs:{"value-type":"format","format":"DD-MM-YYYY","type":"datetime","clearable":false,"placeholder":'Añadir fecha de aprobación',"disabled":_vm.disabled},on:{"input":_vm.changeDate},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})
}
var staticRenderFns = []

export { render, staticRenderFns }